// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ✅ Modern & Clean Search Modal */
.search-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(24, 24, 24, 0.95); /* Dark with slight transparency */
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    padding: 16px;
    width: 480px;
    border-radius: 10px;
    z-index: 1000;
    color: white;
    height: auto;
    max-height: 450px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  }
  
  /* ✅ Close Button */
  .close-btn {
    background: none;
    border: none;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    position: absolute;
    right: 14px;
    top: 10px;
    transition: color 0.3s ease-in-out;
  }
  
  .close-btn:hover {
    color: #ff4d4d;
  }
  
  /* ✅ Search Bar Fix (Prevents Overflow) */
  .search-input {
    width: calc(100% - 28px); /* Adjusted width to fit properly */
    padding: 10px 14px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    outline: none;
    color: white;
    background: rgba(255, 255, 255, 0.1);
    transition: background 0.3s ease-in-out;
    box-sizing: border-box; /* Ensures padding doesn’t exceed width */
  }
  
  
  .search-input::placeholder {
    color: rgba(255, 255, 255, 0.5);
    font-size: 13px;
  }
  
  .search-input:focus {
    background: rgba(255, 255, 255, 0.15);
  }
  
  /* ✅ Search Results Section */
  .search-results {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden; /* Prevents horizontal scrolling */
    width: 100%;
    background: transparent;
    border-radius: 8px;
    padding: 6px 0;
    margin-top: 8px;
  }
  
  /* ✅ Individual Search Result */
  .search-result {
    padding: 10px 12px;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 6px;
    transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;
  }
  
  /* ✅ Session Name (Always on Top) */
  .search-result .session-name {
    font-size: 14px;
    font-weight: bold;
    color: white;
    margin-bottom: 2px;
  }
  
  /* ✅ Highlighted Search Text (Below Session Name) */
  /* ✅ Highlighted Search Text (Now Yellow) */
  .search-result .highlighted-text {
    font-size: 12px;
    color: #ffdd57; /* Yellow highlight */
    font-weight: bold;
  }
  
  
  /* ✅ Hover Effect */
  .search-result:hover {
    background: rgba(255, 255, 255, 0.08);
    transform: scale(1.01);
  }
  
  /* ✅ No Results Message */
  .no-results {
    text-align: center;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    font-style: italic;
  }
  
  /* ✅ Section Headers (Today, Yesterday, etc.) */
  .search-section-header {
    font-size: 12px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.5);
    padding: 5px 12px;
  }
  
  /* ✅ Recent Sessions Section */
  .recent-sessions {
    margin-top: 8px;
    width: 100%;
    text-align: left;
    max-height: 250px;
    overflow-y: auto;
    overflow-x: hidden; /* Ensures no horizontal scrolling */
  }
  
  /* ✅ Recent Sessions List */
  .recent-sessions ul {
    list-style: none;
    padding: 0;
  }
  
  /* ✅ Recent Session Item */
  .recent-sessions li {
    padding: 10px 12px;
    cursor: pointer;
    border-radius: 6px;
    transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;
    font-size: 13px;
  }
  
  .recent-sessions li:hover {
    background: rgba(255, 255, 255, 0.08);
    transform: scale(1.01);
  }
  
  /* ✅ Smooth Minimal Scrollbar */
  .search-results::-webkit-scrollbar,
  .recent-sessions::-webkit-scrollbar {
    width: 5px;
  }
  
  .search-results::-webkit-scrollbar-thumb,
  .recent-sessions::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
  }
  
  .search-results::-webkit-scrollbar-track,
  .recent-sessions::-webkit-scrollbar-track {
    background: transparent;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/styles/SearchHistory.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kCAAkC,EAAE,kCAAkC;IACtE,2BAA2B;IAC3B,mCAAmC;IACnC,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,2CAA2C;EAC7C;;EAEA,mBAAmB;EACnB;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,kCAAkC;EACpC;;EAEA;IACE,cAAc;EAChB;;EAEA,yCAAyC;EACzC;IACE,wBAAwB,EAAE,mCAAmC;IAC7D,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,oCAAoC;IACpC,uCAAuC;IACvC,sBAAsB,EAAE,yCAAyC;EACnE;;;EAGA;IACE,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB,EAAE,kCAAkC;IACtD,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mEAAmE;EACrE;;EAEA,mCAAmC;EACnC;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;EACpB;;EAEA,mDAAmD;EACnD,2CAA2C;EAC3C;IACE,eAAe;IACf,cAAc,EAAE,qBAAqB;IACrC,iBAAiB;EACnB;;;EAGA,mBAAmB;EACnB;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA,yBAAyB;EACzB;IACE,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA,+CAA+C;EAC/C;IACE,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB,EAAE,oCAAoC;EAC1D;;EAEA,2BAA2B;EAC3B;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mEAAmE;IACnE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA,+BAA+B;EAC/B;;IAEE,UAAU;EACZ;;EAEA;;IAEE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB","sourcesContent":["/* ✅ Modern & Clean Search Modal */\r\n.search-modal {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background: rgba(24, 24, 24, 0.95); /* Dark with slight transparency */\r\n    backdrop-filter: blur(10px);\r\n    -webkit-backdrop-filter: blur(10px);\r\n    padding: 16px;\r\n    width: 480px;\r\n    border-radius: 10px;\r\n    z-index: 1000;\r\n    color: white;\r\n    height: auto;\r\n    max-height: 450px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);\r\n  }\r\n  \r\n  /* ✅ Close Button */\r\n  .close-btn {\r\n    background: none;\r\n    border: none;\r\n    font-size: 16px;\r\n    color: rgba(255, 255, 255, 0.6);\r\n    cursor: pointer;\r\n    position: absolute;\r\n    right: 14px;\r\n    top: 10px;\r\n    transition: color 0.3s ease-in-out;\r\n  }\r\n  \r\n  .close-btn:hover {\r\n    color: #ff4d4d;\r\n  }\r\n  \r\n  /* ✅ Search Bar Fix (Prevents Overflow) */\r\n  .search-input {\r\n    width: calc(100% - 28px); /* Adjusted width to fit properly */\r\n    padding: 10px 14px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    outline: none;\r\n    color: white;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    transition: background 0.3s ease-in-out;\r\n    box-sizing: border-box; /* Ensures padding doesn’t exceed width */\r\n  }\r\n  \r\n  \r\n  .search-input::placeholder {\r\n    color: rgba(255, 255, 255, 0.5);\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .search-input:focus {\r\n    background: rgba(255, 255, 255, 0.15);\r\n  }\r\n  \r\n  /* ✅ Search Results Section */\r\n  .search-results {\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden; /* Prevents horizontal scrolling */\r\n    width: 100%;\r\n    background: transparent;\r\n    border-radius: 8px;\r\n    padding: 6px 0;\r\n    margin-top: 8px;\r\n  }\r\n  \r\n  /* ✅ Individual Search Result */\r\n  .search-result {\r\n    padding: 10px 12px;\r\n    font-size: 13px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    border-radius: 6px;\r\n    transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;\r\n  }\r\n  \r\n  /* ✅ Session Name (Always on Top) */\r\n  .search-result .session-name {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: white;\r\n    margin-bottom: 2px;\r\n  }\r\n  \r\n  /* ✅ Highlighted Search Text (Below Session Name) */\r\n  /* ✅ Highlighted Search Text (Now Yellow) */\r\n  .search-result .highlighted-text {\r\n    font-size: 12px;\r\n    color: #ffdd57; /* Yellow highlight */\r\n    font-weight: bold;\r\n  }\r\n  \r\n  \r\n  /* ✅ Hover Effect */\r\n  .search-result:hover {\r\n    background: rgba(255, 255, 255, 0.08);\r\n    transform: scale(1.01);\r\n  }\r\n  \r\n  /* ✅ No Results Message */\r\n  .no-results {\r\n    text-align: center;\r\n    font-size: 12px;\r\n    color: rgba(255, 255, 255, 0.5);\r\n    font-style: italic;\r\n  }\r\n  \r\n  /* ✅ Section Headers (Today, Yesterday, etc.) */\r\n  .search-section-header {\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    color: rgba(255, 255, 255, 0.5);\r\n    padding: 5px 12px;\r\n  }\r\n  \r\n  /* ✅ Recent Sessions Section */\r\n  .recent-sessions {\r\n    margin-top: 8px;\r\n    width: 100%;\r\n    text-align: left;\r\n    max-height: 250px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden; /* Ensures no horizontal scrolling */\r\n  }\r\n  \r\n  /* ✅ Recent Sessions List */\r\n  .recent-sessions ul {\r\n    list-style: none;\r\n    padding: 0;\r\n  }\r\n  \r\n  /* ✅ Recent Session Item */\r\n  .recent-sessions li {\r\n    padding: 10px 12px;\r\n    cursor: pointer;\r\n    border-radius: 6px;\r\n    transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .recent-sessions li:hover {\r\n    background: rgba(255, 255, 255, 0.08);\r\n    transform: scale(1.01);\r\n  }\r\n  \r\n  /* ✅ Smooth Minimal Scrollbar */\r\n  .search-results::-webkit-scrollbar,\r\n  .recent-sessions::-webkit-scrollbar {\r\n    width: 5px;\r\n  }\r\n  \r\n  .search-results::-webkit-scrollbar-thumb,\r\n  .recent-sessions::-webkit-scrollbar-thumb {\r\n    background: rgba(255, 255, 255, 0.3);\r\n    border-radius: 3px;\r\n  }\r\n  \r\n  .search-results::-webkit-scrollbar-track,\r\n  .recent-sessions::-webkit-scrollbar-track {\r\n    background: transparent;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
